// API配置文件
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8081/lethe').replace(/\/$/, '');

export const API_CONFIG = {
    BASE_URL: API_BASE_URL,
    withBase(path = '') {
        return `${API_BASE_URL}${path}`;
    },
};

export default API_CONFIG;
export { API_BASE_URL };
